<lx-loading-spinner
  [message]="loadingInfo().message"
  [loading]="loadingInfo().loading"
  shadingColor="rgba(0,0,0,0.5)"
  [positionRelative]="false"
></lx-loading-spinner>

<div class="app-wrapper">
  <!-- Elfsight Announcement Bar | Kaplan Disclaimer - Desktop ribbon [EN] -->
  <div class="elfsight-app-e9797d7c-ed8e-4ad3-98c6-1d1bc3fff4b8 app-wrapper__elfsight-app" data-elfsight-app-lazy></div>
  <router-outlet></router-outlet>
</div>
